import { render, staticRenderFns } from "./omr-quiz-results-dashboard.html?vue&type=template&id=c9616186&scoped=true&"
import script from "./omr-quiz-results-dashboard.vue?vue&type=script&lang=js&"
export * from "./omr-quiz-results-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./omr-quiz-results-dashboard.css?vue&type=style&index=0&id=c9616186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9616186",
  null
  
)

export default component.exports